import { ButtonVariants, Menu, MenuItem } from '@triumph/design-system';
import { useNavigate } from 'react-router-dom';

import { usePermissions } from '@/components/providers/PermissionsContextProvider';
import { Feature } from '@/components/shared/constants/features';
import { PageRoutes } from '@/components/shared/routes';

export const HeaderDebugMenu = () => {
    const { hasFeature } = usePermissions();
    const navigate = useNavigate();

    // Hidden rather than disabled, because the header is on every page and only admins can use it.
    if (!hasFeature(Feature.DebugMenu)) return null;

    return (
        <div data-testid="header-debug-menu">
            <Menu label="DEBUG" variant={ButtonVariants.secondary} bold>
                <MenuItem
                    label="Open Hangfire Dashboard"
                    onClick={() => navigate(PageRoutes.HANGFIRE_DASHBOARD)}
                />
                <MenuItem
                    label="Preview Email Templates"
                    onClick={() => navigate(PageRoutes.EMAIL_TEMPLATE_PREVIEW)}
                />
            </Menu>
        </div>
    );
};
